import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import { darken, rgba } from 'polished';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import InfoIcon from '@components/basics/icons/info';
import Typography from '@components/basics/typography';

interface HelpWidgetProps {
  className?: string;
}

const HelpWidget: FunctionComponent<HelpWidgetProps> = ({ className }) => {
  const iconAnimate = {
    initial: {
      y: 0,
    },
    visible: {
      y: -4,
      transition: {
        duration: 0.4,
        yoyo: Infinity,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.a
      className={className || ''}
      href="https://tracco.zendesk.com/hc/"
      target="_blank"
      rel="noopener noreferrer"
      initial="initial"
      whileHover="visible"
    >
      <IconWrapper>
        <InfoIcon variants={iconAnimate} />
      </IconWrapper>
      <Info>
        <Title customFont="bold">
          <Translate id="DASHBOARD.NEW_DASHBOARD.HELP.TITLE" />
        </Title>
        <Text>
          <Translate id="DASHBOARD.NEW_DASHBOARD.HELP.SUBTITLE" />
        </Text>
      </Info>
    </motion.a>
  );
};

export default styled(HelpWidget)`
  cursor: pointer;
  padding: 32px;
  height: max-content;
  border-radius: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.midGray};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.midGray)};
  }
`;

const IconWrapper = styled.div`
  flex: 0 0 auto;
  width: 68px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ theme }) => rgba(theme.colors.upload, 0.1)};

  svg {
    width: 18px;
    height: 18px;
  }
`;

const Info = styled.div``;

const Title = styled(Typography)`
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Text = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.span};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.tertiary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
